import Vue from 'vue';
import store from './../../store';

const GET_LIST_ENTRIES_URL = '/api/v1/lists/';

const successGetListEntries = (response) => {
  store.dispatch('getListEntries', response.data);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedGetListEntries = () => {
  // console.log('failedGetListEntries');
  // console.log(error);
};

export default (listid, pagestart, pagelength, skipToID) => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  // const queryinfo = {
  //   url: urltoquery,
  // };
  let thisurl = `${GET_LIST_ENTRIES_URL}${listid}/entries?page=${pagestart}&size=${pagelength}`;
  if (skipToID) {
    thisurl = `${GET_LIST_ENTRIES_URL}${listid}/entries?skip_to_id=${skipToID}`;
  }

  Vue.$http.get(thisurl, axiosOptions)
   .then((response) => {
     successGetListEntries(response);
   })
   .catch((error) => {
     failedGetListEntries(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/getlistentries.js